// TODO: Fix all linting warnings in layout-lib #36010
/* eslint-disable */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private _isVisible = new BehaviorSubject<boolean>(false);
  public isVisible$ = this._isVisible.asObservable();

  public setVisibilityState(state: boolean): void {
    this._isVisible.next(state);
  }

  public getVisibilityState(): boolean {
    return this._isVisible.getValue();
  }

  constructor() {}
}
